export default "__VITE_ASSET__3Rh8BZpB__"